import { ThemeEvents } from '@theme/events';
class LsfProductAvailability extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.closest('.shopify-section')?.addEventListener(ThemeEvents.variantUpdated, event => {
      const productId = event.detail?.data?.productId;
      if (productId && String(productId) !== this.dataset.productId) return;
      const variant = event.detail.resource;
      const available = Boolean(variant?.available);
      this.dataset.available = String(available);
      this.dataset.variantId = variant?.id || '';
      this.textContent = available ? this.dataset.availableLabel : this.dataset.unavailableLabel;
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('lsf-product-availability')) customElements.define('lsf-product-availability', LsfProductAvailability);
